import { Box, Container, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const ThankYouPage = () => {
  return (
    <Box
      sx={{
        flexWrap: { xs: "wrap", lg: "nowrap" },
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={4} textAlign="center" alignItems="center">
          <CheckCircleOutlineIcon
            sx={{ fontSize: 72, color: "success.main" }}
          />

          <Typography variant="h4" fontWeight={600}>
            Thank you.
          </Typography>

          <Typography color="text.secondary">
            Your deduction-authorization form has been successfully submitted. A
            confirmation e-mail has been sent.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
};

export default ThankYouPage;
